import Attachment from './Attachment'
import type { IDocument } from '@/interfaces/IDocument'
import Base from './Base'
import type { IAttachment } from '@/interfaces'

class DocumentModel extends Base implements IDocument {
  index?: number | undefined
  title: string
  type: string
  attachment: IAttachment

  constructor(document?: any) {
    super(document)
    this.index = document?.index || null
    this.title = document?.title || ''
    this.type = document?.type || ''
    this.attachment = new Attachment(document?.attachment) || null
  }
}

export default DocumentModel
